import styled from "@emotion/styled";
import Presentation from "./PresentationMode";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  overflow: clip;
`;

const Content = styled.div`
  flex: 1;
  width: 100%;
`;

const PresentationFullWidthPage = () => {
  return (
    <Container>
      <Content>
        <Presentation />
      </Content>
    </Container>
  );
};

export default PresentationFullWidthPage;
